module.exports = __webpack_public_path__ + "img/episode2.193b3f26.png";